var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame146(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1686_2215)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.6575,
    y: 45.6577,
    width: 22.3429,
    height: 22.3429,
    fill: "#199FDA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.3137,
    y: 23.3154,
    width: 22.3429,
    height: 22.3429,
    fill: "#F8CC07"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.972168,
    y: 45.6577,
    width: 22.3429,
    height: 22.3429,
    fill: "#9628C6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.6575,
    y: 0.97168,
    width: 22.3429,
    height: 22.3429,
    fill: "#E2203D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1686_2215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame146);
export default __webpack_public_path__ + "static/media/Frame 146.3b76bb80f005728ec13c8b3d452b47ad.svg";
export { ForwardRef as ReactComponent };